export default __webpack_public_path__ + "static/Amar-94a739baaa5c82bb987e04168dc2e5b9.png";